import {
  LayoutDashboard, Radio, CalendarClock, Sparkles, BarChart3, History, Bell, Crown, User, Settings,
  ListChecks, Ticket, LifeBuoy,
  type LucideIcon,
} from "lucide-react";
import type { Dict } from "@/i18n/tr";
import { ATLAS_ASSISTANT_ENABLED } from "@/config/features";

export interface NavItem {
  to: string;
  icon: LucideIcon;
  label: (d: Dict) => string;
  key: string;
  primary?: boolean; // shown in mobile bottom nav
}

const ALL_APP_NAV: NavItem[] = [
  { to: "/app", icon: LayoutDashboard, label: (d) => d.nav.dashboard, key: "dashboard", primary: true },
  { to: "/app/live", icon: Radio, label: (d) => d.nav.live, key: "live", primary: true },
  { to: "/app/prematch", icon: CalendarClock, label: (d) => d.nav.prematch, key: "prematch", primary: true },
  { to: "/app/atlas", icon: Sparkles, label: (d) => d.nav.atlas, key: "atlas", primary: true },
  { to: "/app/analysis", icon: ListChecks, label: (d) => d.nav.analysis, key: "analysis" },
  { to: "/app/performance", icon: BarChart3, label: (d) => d.nav.performance, key: "performance" },
  { to: "/app/history", icon: History, label: (d) => d.nav.history, key: "history" },
  { to: "/app/notifications", icon: Bell, label: (d) => d.nav.notifications, key: "notifications" },
  { to: "/app/membership", icon: Crown, label: (d) => d.nav.membership, key: "membership", primary: true },
  { to: "/app/coupons", icon: Ticket, label: (d) => d.nav.coupons, key: "coupons" },
  { to: "/app/support", icon: LifeBuoy, label: (d) => d.nav.support, key: "support" },
  { to: "/app/account", icon: User, label: (d) => d.nav.account, key: "account" },
  { to: "/app/settings", icon: Settings, label: (d) => d.nav.settings, key: "settings" },
];

export const APP_NAV: NavItem[] = ALL_APP_NAV.filter((n) => n.key !== "atlas" || ATLAS_ASSISTANT_ENABLED);
